import request from './request';
export function sendRedPacket(data) {
  return request.post('/api/red_packet/send', data);
}
export function grabRedPacket(redpacketId) {
  return request.post('/api/red_packet/grab', { redpacket_id: redpacketId });
}
export function getPacketList(roomId) {
  return request.get('/api/red_packet/packetList', { params: { room_id: roomId } });
}
export function getMyPacketRecords() {
  return request.get('/api/red_packet/myRecords');
}
